var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M19,22H17a3,3,0,0,1-3-3V18a3,3,0,0,1,3-3h1a3,3,0,1,1,3-3,3,3,0,0,1-3,3h1a3,3,0,0,1,3,3v1A3,3,0,0,1,19,22Zm-2-5a1,1,0,0,0-1,1v1a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1Zm1-6a1,1,0,1,0,1,1A1,1,0,0,0,18,11ZM5,22H3a3,3,0,0,1-3-3V18a3,3,0,0,1,3-3H4a3,3,0,1,1,3-3,3,3,0,0,1-3,3H5a3,3,0,0,1,3,3v1A3,3,0,0,1,5,22ZM3,17a1,1,0,0,0-1,1v1a1,1,0,0,0,1,1H5a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1Zm1-6a1,1,0,1,0,1,1A1,1,0,0,0,4,11Zm8,2H10a3,3,0,0,1-3-3V9a3,3,0,0,1,3-3h1a3,3,0,1,1,3-3,3,3,0,0,1-3,3h1a3,3,0,0,1,3,3v1A3,3,0,0,1,12,13ZM10,8A1,1,0,0,0,9,9v1a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1Zm1-6a1,1,0,1,0,1,1A1,1,0,0,0,11,2Z",
    fill: "#92929d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.d704f78b.svg";
export { ForwardRef as ReactComponent };